export default __webpack_public_path__ + "static/media/fureverhomes5.cbe5eba3.png";